import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=50a1fbba"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=50a1fbba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports